import styles from "./YuJaButton.module.css";
import { Button } from '@base-ui/react/button';
import React from 'react';

/**
 *
 * @param type {'primary' | 'secondary' | 'delete' | 'deleteImage'}
 * @param size {'small' | 'medium' | 'large'}
 * @param isLoading boolean
 * @returns {JSX.Element}
 */
const YuJaButton = React.forwardRef((
    {
        children,
        type = "primary",
        size = "medium",
        isLoading=false,
        iconOnly=false,
        ...rest
    },
    ref
) => {



    let sizeClassName;
    if (size === "small") {
        sizeClassName = styles.small;
    } else if (size === "large") {
        sizeClassName = styles.large;
    } else {
        sizeClassName = styles.medium;
    }

    let typeClassName;

    if (type === "primary") {
        typeClassName = styles.primary;
    } else if (type === "secondary") {
        typeClassName = styles.secondary;
    } else if (type === "delete") {
        typeClassName = styles.delete;
    } else if (type === "deleteImage") {
        typeClassName = styles.deleteImage;
    } else {
        typeClassName = "";
    }

    if (iconOnly) {
        return (
            <Button
                {...rest}
                className={styles.iconContainer}
                ref={ref}
                focusableWhenDisabled={isLoading}
            >
                {children}
            </Button>
        );
    }


    return (
        <Button
            {...rest}
            className={`${styles.container} ${typeClassName} ${sizeClassName}`}
            ref={ref}
            focusableWhenDisabled={isLoading}
        >
            {children}
        </Button>
    );
});


export default YuJaButton;